export const mobileSizes = {
  xs: {
    width: 105,
    height: 224,
    padding: 6
  },
  lg: {
    width: 175,
    height: 373,
    padding: 6
  },
  xl: {
    width: 245,
    height: 522,
    padding: 6
  }
};

export const mobileMapSizes = {
  xl: {
    width: 1946,
    height: 1387
  },
  lg: {
    width: 1391,
    height: 991
  },
  xs: {
    width: 836,
    height: 595
  }
};

export const transitionOptions = {
  from: {
    opacity: 0,
    x: 60
  },
  to: [
    {
      opacity: 1,
      x: 0,
      config: {
        duration: 400
      },
      delay: 6000
    },
    {
      opacity: 0,
      x: 60,
      config: {
        duration: 400
      },
      delay: 3600
    }
  ],
  loop: {
    from: {
      opacity: 0,
      x: 60
    },
    delay: 2800
  }
}

export const style = {
  xs: {
    container: {
      top: "84px",
      left: "-42px"
    },
    icon: {
      width: "10px",
      height: "10px"
    }
  },
  lg: {
    container: {
      top: "139px",
      left: "-70px"
    },
    icon: {
      width: "17px",
      height: "17px"
    }
  },
  xl: {
    container: {
      top: "195px",
      left: "-98px"
    },
    icon: {
      width: "25px",
      height: "25px"
    }
  }
}